import React from 'react';
import Header from '../components/Header/Header';
import StarlinkHero from '../components/StarlinkHero/StarlinkHero';
import StatsCounter from '../components/StatsCounter/StatsCounter';
import StarlinkTracker from '../components/StarlinkTracker/StarlinkTracker';
import VehicleTracking from '../components/VehicleTracking/VehicleTracking';
import DualProtection from '../components/DualProtection/DualProtection';
import StarlinkTestimonials from '../components/StarlinkTestimonials/StarlinkTestimonials';
import StarlinkFAQ from '../components/StarlinkFAQ/StarlinkFAQ';
import StarlinkPricing from '../components/StarlinkPricing/StarlinkPricing';
import StarlinkCTA from '../components/StarlinkCTA/StarlinkCTA';
import Footer from '../components/Footer/Footer';
import BackgroundVideo from '../components/BackgroundVideo/BackgroundVideo';
import ChatBot from '../components/ChatBot/ChatBot';
import { useIntersectionObserver } from '../hooks/useIntersectionObserver';
import './StarlinkPage.scss';

const StarlinkPage: React.FC = () => {
  const currentSection = useIntersectionObserver();

  return (
    <>
      <BackgroundVideo currentSection={currentSection} />
      <div className="starlink-page">
        <Header />
        <StarlinkHero />
        <StatsCounter />
        <StarlinkTracker />
        <VehicleTracking />
        <DualProtection />
        <StarlinkTestimonials />
        <StarlinkFAQ />
        <StarlinkPricing />
        <StarlinkCTA />
        <Footer />
      </div>
      <ChatBot />
    </>
  );
};

export default StarlinkPage;
